import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './CardContainer.scss';
const rootClassName = styles.rootClassName;

class CardContainer extends Component {
  hasBullets = false;
  hasFooterItems = false;

  getBullet(index, isCurrent) {
    const className =
      rootClassName +
      '-bullet ' +
      (isCurrent ? rootClassName + '-bullet-actived' : '');
    return <div className={className} key={index}></div>;
  }

  getBullets() {
    if (!this.hasBullets) {
      return <></>;
    }
    let bulletElements = [];
    for (let i = 0; i < this.props.totalSteps; ++i) {
      bulletElements.push(this.getBullet(i, this.props.currStep - 1 === i));
    }
    return (
      <div className={rootClassName + '-bullets'}>
        {bulletElements.map((bullet) => {
          return bullet;
        })}
      </div>
    );
  }

  getFooterItems() {
    if (!this.hasFooterItems) {
      return <></>;
    }
    const className =
      rootClassName +
      '-footer-items ' +
      (this.hasBullets ? rootClassName + '-footer-items-with-bullets' : '');
    return <div className={className}>{this.props.footerItems}</div>;
  }

  render() {
    const classes = this.props.className
      ? this.props.className + ' ' + rootClassName
      : rootClassName;
    this.hasBullets =
      this.props.currStep && this.props.totalSteps && this.props.totalSteps > 1
        ? true
        : false;
    this.hasFooterItems = this.props.footerItems ? true : false;
    return (
      <div className={classes}>
        {this.props.children}
        {this.hasBullets ? this.getBullets() : ''}
        {this.hasFooterItems ? this.getFooterItems() : ''}
      </div>
    );
  }
}

CardContainer.propTypes = {
  className: PropTypes.string,
  currStep: PropTypes.number,
  totalSteps: PropTypes.number,
  footerItems: PropTypes.object,
};

export default CardContainer;
